import axios from "axios";
import { getEnv } from "../config";

const api = axios.create({
  baseURL: getEnv("REACT_APP_API_URL"),
  withCredentials: true,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
  // si usás CSRF:
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-CSRF-TOKEN", // que coincida con tu backend
});

// api.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     return Promise.reject(err);
//   }
// );

export default api;
